import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';

@Component({
  selector: 'sc-field-datetime-picker',
  templateUrl: './field-datetime-picker.component.html',
  styleUrls: ['./field-datetime-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldDatetimePickerComponent extends FieldType implements OnInit {
  ngOnInit(): void {}
}
